"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _formik = require("formik");
var _Translations = require("react-platform-components/dist/Translations");
var Yup = _interopRequireWildcard(require("yup"));
var _reactRedux = require("react-redux");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CreationSchema = Yup.object().shape({
  password: Yup.string().required( /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Ce champ est requis",
    defaultMessage: "Ce champ est requis"
  })),
  new_password: Yup.string().required( /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Ce champ est requis",
    defaultMessage: "Ce champ est requis"
  })),
  new_password_confirm: Yup.string().oneOf([Yup.ref('new_password'), null], /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Les mots de passe ne correspondent pas",
    defaultMessage: "Les mots de passe ne correspondent pas"
  })).required( /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Ce champ est requis",
    defaultMessage: "Ce champ est requis"
  }))
});
var ChangePasswordTab = /*#__PURE__*/function (_React$Component) {
  _inherits(ChangePasswordTab, _React$Component);
  var _super = _createSuper(ChangePasswordTab);
  function ChangePasswordTab(props) {
    var _this;
    _classCallCheck(this, ChangePasswordTab);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleClickShowPassword", function () {
      _this.setState({
        showPassword: !_this.state.showPassword
      });
    });
    _this.state = {
      showPassword: false
    };
    return _this;
  }
  _createClass(ChangePasswordTab, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "m-4 md:m-8"
      }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
        elevation: 3,
        className: "p-4 md:p-16",
        style: {
          boxShadow: '4px 3px 20px #c7c7c7'
        }
      }, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
        initialValues: {
          password: '',
          new_password: '',
          new_password_confirm: ''
        },
        onSubmit: function onSubmit(values) {
          // console.log(values)
          _this2.props.dispatch({
            type: 'CHANGE_PASSWORD',
            model: values,
            history: _this2.props.history
          });
        },
        validationSchema: CreationSchema,
        render: function render(props) {
          return /*#__PURE__*/_react.default.createElement("form", {
            onSubmit: props.handleSubmit
          }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
            container: true
          }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
            item: true,
            xs: 12,
            style: {
              marginBottom: 16
            }
          }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
            type: _this2.state.showPassword ? 'text' : 'password',
            name: "password",
            label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
              id: "Ancien mot de passe",
              defaultMessage: "Ancien mot de passe"
            }),
            required: true,
            fullWidth: true,
            variant: "outlined",
            onChange: props.handleChange,
            value: props.values.password,
            helperText: props.errors.password && props.touched.password ? props.errors.password : null,
            error: props.touched.password && props.errors.password ? true : false,
            InputProps: {
              endAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
                position: "end"
              }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
                edge: "end",
                onClick: _this2.handleClickShowPassword
              }, _this2.state.showPassword ? /*#__PURE__*/_react.default.createElement(_core.Icon, null, "visibility_off") : /*#__PURE__*/_react.default.createElement(_core.Icon, null, "visibility")))
            }
          })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
            item: true,
            xs: 12,
            style: {
              marginBottom: 16
            }
          }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
            type: _this2.state.showPassword ? 'text' : 'password',
            name: "new_password",
            label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
              id: "Mot de passe",
              defaultMessage: "Mot de passe"
            }),
            required: true,
            fullWidth: true,
            variant: "outlined",
            onChange: props.handleChange,
            value: props.values.new_password,
            helperText: props.errors.new_password && props.touched.new_password ? props.errors.new_password : null,
            error: props.touched.new_password && props.errors.new_password ? true : false,
            InputProps: {
              endAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
                position: "end"
              }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
                edge: "end",
                onClick: _this2.handleClickShowPassword
              }, _this2.state.showPassword ? /*#__PURE__*/_react.default.createElement(_core.Icon, null, "visibility_off") : /*#__PURE__*/_react.default.createElement(_core.Icon, null, "visibility")))
            }
          })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
            item: true,
            xs: 12,
            style: {
              marginBottom: 16
            }
          }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
            type: _this2.state.showPassword ? 'text' : 'password',
            name: "new_password_confirm",
            label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
              id: "Confirmez le mot de passe",
              defaultMessage: "Confirmez le mot de passe"
            }),
            required: true,
            fullWidth: true,
            variant: "outlined",
            onChange: props.handleChange,
            value: props.values.new_password_confirm,
            helperText: props.errors.new_password_confirm && props.touched.new_password_confirm ? props.errors.new_password_confirm : null,
            error: props.touched.new_password_confirm && props.errors.new_password_confirm ? true : false,
            InputProps: {
              endAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
                position: "end"
              }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
                edge: "end",
                onClick: _this2.handleClickShowPassword
              }, _this2.state.showPassword ? /*#__PURE__*/_react.default.createElement(_core.Icon, null, "visibility_off") : /*#__PURE__*/_react.default.createElement(_core.Icon, null, "visibility")))
            }
          })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
            item: true,
            container: true,
            justify: "flex-end",
            alignItems: "center",
            xs: 12
          }, /*#__PURE__*/_react.default.createElement(_core.Button, {
            type: "submit",
            variant: "contained",
            color: "primary",
            className: "ml-a mt-16 normal-case"
          }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Modifier",
            defaultMessage: "Modifier"
          })))));
        }
      })));
    }
  }]);
  return ChangePasswordTab;
}(_react.default.Component);
var _default = (0, _reactRedux.connect)()(ChangePasswordTab);
exports.default = _default;